import { FieldProps } from 'formik';
import classNames from 'classnames';
import React, { createRef, useEffect, useState } from 'react';

import Eye from '../statics/images/eye.svg';
import InfoCircle from '../statics/images/info-circle.svg';

interface Props extends FieldProps {
  type: string;
  unit?: string;
  label?: string;
  setInputValue?: (t: any) => void;
}

const EyeIcon = ({ onClick }: { onClick: () => void }) => {
  return <img className="icon eye-icon" src={Eye} onClick={onClick} alt="" />;
};

export const InfoCircleIcon = () => {
  return <img className="icon" src={InfoCircle} alt="" />;
};

function TextInput({
  field,
  form: { touched, errors, setFieldValue },
  type,
  unit,
  label,
  setInputValue,
  ...props
}: Props) {
  let inputHtmlType = type;
  if (type === 'percent') {
    inputHtmlType = 'text';
  }
  const [inputType, setInputType] = useState(inputHtmlType);
  const inputRef: any = createRef();

  const eyeClickHandler = () => {
    if (inputType === 'password') {
      setInputType('text');
    } else {
      setInputType('password');
    }
  };

  const renderEyeIcon = () => {
    return type === 'password' ? <EyeIcon onClick={eyeClickHandler} /> : null;
  };

  const handleInput = (e: any) => {
    setFieldValue(field.name, e.target.value);
    if (setInputValue) {
      setInputValue(e.target.value);
    }
  };

  useEffect(() => {
    if (inputType === 'TwoFACode' && inputRef && inputRef.current) {
      inputRef.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="form-field-group">
      <div
        className={classNames('p-inputgroup', {
          'p-invalid': touched[field.name] && errors[field.name],
        })}
      >
        {label && <span className="input-label">{label}</span>}
        <input type={inputType} {...field} {...props} onChange={handleInput} />
        {touched[field.name] && errors[field.name] ? <InfoCircleIcon /> : renderEyeIcon()}
        {type === 'percent' && <span className="percentage">%</span>}
        {unit && <span className="input-unit">{unit}</span>}
      </div>
      {touched[field.name] && errors[field.name] && <div className="input-feedback">{errors[field.name]}</div>}
    </div>
  );
}

export default TextInput;
